var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPerson(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/filled/person",
    clipPath: "url(#clip0_2811_114369)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    d: "M14.3334 12.161V13.9842C14.3325 14.3064 14.1917 14.6152 13.9418 14.8431C13.6919 15.0709 13.3532 15.1992 12.9997 15.2H3.0003C2.64686 15.1992 2.30813 15.0709 2.05821 14.8431C1.80829 14.6152 1.66752 14.3064 1.66669 13.9842V12.161C1.66919 11.3557 2.0212 10.5841 2.64581 10.0146C3.27042 9.4452 4.11686 9.12429 5.00019 9.12201H10.9999C11.8832 9.12429 12.7296 9.4452 13.3542 10.0146C13.9788 10.5841 14.3309 11.3557 14.3334 12.161ZM4.59389 5.10425C4.5941 4.49014 4.79404 3.88987 5.16844 3.37935C5.54284 2.86883 6.07487 2.47097 6.69728 2.2361C7.31969 2.00122 8.00451 1.93986 8.66517 2.05978C9.32582 2.17971 9.93264 2.47553 10.4089 2.90983C10.8851 3.34414 11.2094 3.89744 11.3408 4.49976C11.4721 5.10209 11.4046 5.72639 11.1468 6.29374C10.8889 6.86108 10.4524 7.34599 9.89225 7.68716C9.33214 8.02832 8.67364 8.21041 8.00002 8.21041C7.09666 8.21041 6.2303 7.88326 5.59152 7.30092C4.95275 6.71858 4.59389 5.9278 4.59389 5.10425Z",
    fill: "white",
    fillOpacity: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2811_114369"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 14.4,
    fill: "white",
    transform: "translate(0 0.800049)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPerson);
export default __webpack_public_path__ + "static/media/icon_person.999011d8d82e05a2681536ce891b2acb.svg";
export { ForwardRef as ReactComponent };